// extracted by mini-css-extract-plugin
export default {"root":"WellBeingForm_root__YKhWn","radioGroup":"WellBeingForm_radioGroup__-hvN2"};